import { useState } from "react";
import { signInWithEmail } from "./authService";
import useAuthStore from "./store/authStore";
import 'material-icons/iconfont/material-icons.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const setUser = useAuthStore((state) => state.setUser);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const user = await signInWithEmail(email, password);
      setUser(user);
    } catch (error) {
      let errorMessage;

      switch (error.code) {
        case "auth/invalid-email":
          errorMessage = "Invalid Email. Please try again.";
          break;
        case "auth/invalid-credential":
          errorMessage = "Invalid Email or Password. Please try again.";
          break;
        case "auth/too-many-requests":
          errorMessage = "Too many Requests. Please try later.";
          break;
        default:
          errorMessage = "An error occurred. Please try again.";
          break;
      }

      setError(errorMessage);
      setTimeout(() => {
        setError(null);
      }, 3000);
    }
  };

  return (
    <div className="login-form">
      { error && <div className="error-msg"><span className="material-icons">error</span> {error}</div> }

      <form onSubmit={handleLogin}>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" autoComplete="off" />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" autoComplete="off" />
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;
